module.exports = __webpack_public_path__ + "img/btn.1a80c471.webp";